import { InfoLeagueProps } from '../leagues.props';
import { Tanzanite } from './Tanzanite';

export const TanzaniteLeague: InfoLeagueProps = {
  id: `${process.env.REACT_APP_ID_LEAGUE_TANZANITE}`,
  name: 'Tanzanita',
  description: 'De élite. Recompensas superiores.',
  icon: '💜',
  active: false,
  color: '#FFFFFF',
  bgColor: '#4B3F72',
  borderColor: '#4B3F72',
  path: '/tanzanite',
  page: Tanzanite,
};
